import { useMediaQuery } from 'usehooks-ts';

export default function Mobile({ children }: React.PropsWithChildren) {
  const matches = useMediaQuery('(max-width: 991px)');
  if (!matches) return null;
  return children;
}
